import { AccountingProduct } from "../../classes";
import i18n from '@/plugins/vue-i18n'

const AccountingProductsModule = {
  namespaced: true,
  state: {
    accountingProducts: []
  },
  actions: {
    getAccountingProducts: async ({ commit }, projectId) => {
      try {
        const data = await AccountingProduct.getAccountingProducts({
          projectId: projectId,
        });
        commit("setAccountingProducts", {
          accountingProducts: data
        });
        return data;
      } catch (err) {
        throw err;
      }
    },
    createAccountingProduct: async ({ commit }, formData) => {
      try {
        const data = await AccountingProduct.createAccountingProduct(formData);
        commit("addAccountingProducts", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateAccountingProduct: async ({ commit }, formData) => {
      try {
        const data = await AccountingProduct.updateAccountingProduct(formData);
        commit("updateAccountingProducts", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    getAccountingProductsByIds: async ({ commit }, ids) => {
      try {
        const data = await AccountingProduct.getAccountingProductsByIds(ids);
        commit("updateAccountingProductsByProducts", data);
        return data
      } catch (err) {
        throw err
      }
    },
    removeAccountingProduct: async ({ commit }, accountingProductId) => {
      try {
        const data = await AccountingProduct.removeAccountingProduct(accountingProductId);
        commit("removeAccountingProduct", data);
        return data
      } catch (err) {
        throw err
      }
    },
  },
  getters: {
    getAccountingProducts: state => {
      return state.accountingProducts.filter(d => !d.isRemoved)
    },
    getAccountingProductDiscounts: state => {
      return state.accountingProducts.filter(d => !d.isRemoved && d.type == 'discount')
    },
    getAccountingProductsWithLabel: state => billingSettingType =>
      state.accountingProducts
        .filter(item => {
          let types = ["service", "rental", "facility", "deposit", "discount"]
          if(types.indexOf(item.type) > -1) return item
        })
        .map(item => {
          item.label = `[${item.typeString}] ${item.name} @${item.unit}`;
          item.billing = {
            accountingProductId: item.objectId,
            cost: null,
            type: billingSettingType && billingSettingType == 'daily' ? "daily" : "monthly"
          };
          if (item.type == "service" || item.type == "rental" || item.type == "discount") {
            if (billingSettingType && billingSettingType == 'daily') {
              item.returnListSelect = [
                { text: i18n.t('setting.setting_type.daily'), value: "daily" },
                { text: i18n.t('setting.setting_type.booking'), value: "booking" },
                { text: i18n.t('setting.setting_type.daily_square_metre'), value: "daily_square_metre" },
                { text: i18n.t('setting.setting_type.booking_square_metre'), value: "booking_square_metre" },
              ]
            } else {
              item.returnListSelect = [
                { text: i18n.t('setting.setting_type.monthly'), value: "monthly" },
                { text: i18n.t('setting.setting_type.day_of_month'), value: "day_of_month" },
                { text: i18n.t('setting.setting_type.monthly_square_metre'), value: "monthly_square_metre" },
                { text: i18n.t('setting.setting_type.day_of_month_square_metre'), value: "day_of_month_square_metre" },
              ]
            }
          } else {
            if (billingSettingType && billingSettingType == 'daily') {
              item.returnListSelect = [
                { text: i18n.t('setting.setting_type.daily'), value: "daily" },
                { text: i18n.t('setting.setting_type.booking'), value: "booking" },
              ]
            } else {
              item.returnListSelect = [
                { text: i18n.t('setting.setting_type.monthly'), value: "monthly" },
                { text: i18n.t('setting.setting_type.quantity'), value: "quantity" },
                { text: i18n.t('setting.setting_type.day_of_month'), value: "day_of_month" },
                { text: i18n.t('setting.setting_type.minimum_unit'), value: "minimum_unit" },
                { text: i18n.t('setting.setting_type.minimum_cost'), value: "minimum_cost" },
                { text: i18n.t('setting.setting_type.step'), value: "step" },
              ]
            }
          }
          return item;
        }
      ),
    getAccountingProductService: state => billingSettingType =>
      state.accountingProducts.filter(item => {
        let types = ["service", "rental", "discount"]
        if (types.indexOf(item.type) > -1) {
          item.label = `[${item.typeString}] ${item.name} @${item.unit}`;
          item.billing = {
            accountingProductId: item.objectId,
            cost: null,
            type: billingSettingType && billingSettingType == 'daily' ? "daily" : "monthly"
          };
          return item;
        }
      }),
    getAccountingProductFacility: state => billingSettingType =>
      state.accountingProducts.filter(item => {
        let types = ["facility", "discount"]
        if (types.indexOf(item.type) > -1) {
          item.label = `[${item.typeString}] ${item.name} @${item.unit}`;
          item.billing = {
            accountingProductId: item.objectId,
            cost: null,
            type: billingSettingType && billingSettingType == 'daily' ? "daily" : "monthly"
          };
          return item;
        }
      }),
      getAccountingProductPenalty: state =>
      state.accountingProducts.filter(item => {
        let types = ["penalty"]
        if (types.indexOf(item.type) > -1) {
          item.label = `[${item.typeString}] ${item.name} @${item.unit}`;
          return item;
        }
      }),
    getHashAccountingProduct: (state) => {
      let hash = {}
      for (let accountingProduct of state.accountingProducts) {
        hash[accountingProduct.objectId] = accountingProduct
      }
      return hash
    }
  },
  mutations: {
    setAccountingProducts: (state, payload) => {
      state.accountingProducts = payload.accountingProducts;
    },
    addAccountingProducts: (state, product) => {
      state.accountingProducts.push(product);
    },
    updateAccountingProducts: (state, product) => {
      if (product && state.accountingProducts) {
        let index = state.accountingProducts.findIndex(
          i => i.objectId === product.objectId
        );
        state.accountingProducts[index] = product;
      }
    },
    updateAccountingProductsByProducts: (state, products) => {
      for (let area of products) {
        let index = state.accountingProducts.findIndex(i => i.objectId === area.objectId);
        if (index > -1) {
          state.accountingProducts[index] = area;
        } else {
          state.accountingProducts.push(area)
        }
        const temp = state.accountingProducts
        state.accountingProducts = []
        state.accountingProducts = temp
      }
    },
    removeAccountingProduct(state, accountingProduct) {
      if (state.accountingProducts) {
        let index = state.accountingProducts.findIndex(i => i.objectId === accountingProduct.objectId);
        state.accountingProducts.splice(index, 1);
      }
    },
  }
};
export default AccountingProductsModule;
